import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isCheckboxGroup(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHECKBOX_GROUP && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatCheckboxGroup(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatCheckboxGroup(submission) {
  if (isCheckboxGroup(submission)) {
    return _formatCheckboxGroup(submission);
  }
  return undefined;
}
//# sourceMappingURL=checkbox-group-preview.js.map